module.exports = __webpack_public_path__ + "assets/new-pinterest.5110f15b.svg";